<if(input.help)>
  <div class="map-help">
    <ebay-infotip
      a11y-close-button-text=(input.help.messageDismiss?.textSpans?.[0].text)
      aria-label=(input.help.bubbleIcon?.accessibilityText)
      pointer="right-top"
      open=state.opened
    >
      <@heading>
        <fe-textual-display model=(input.help.title)/>
      </@heading>
      <@content>
        <p>
          <fe-textual-display model=(input.help.messageText?.[0])/>
        </p>
      </@content>
    </ebay-infotip>
  </div>
</if>
